import { render } from "./view-sales.vue?vue&type=template&id=10b68b92"
import script from "./view-sales.vue?vue&type=script&lang=js"
export * from "./view-sales.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\bmac\\ims-web-api\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__